var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import Code02Svg from './code-02.icon.svg';
export const Code02Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: Code02Svg }));
_react_refresh_temp_1 = Code02Icon;
$RefreshReg$(_react_refresh_temp_1, "Code02Icon");
